import {ChangeDetectorRef, Component, EventEmitter, Input, NgModule, Output, SimpleChanges, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxButtonModule, DxDateBoxModule, DxFormComponent, DxFormModule, DxNumberBoxModule, DxSelectBoxModule,
  DxTextBoxModule, DxToolbarModule,
  DxValidatorModule,
  DxScrollViewModule
} from 'devextreme-angular';
// import { FormTextboxModule } from 'src/app/components/utils/form-textbox/form-textbox.component';
// import { FormPhotoModule } from 'src/app/components/utils/form-photo/form-photo.component';
import { ApplyPipeModule } from '../../../pipes/apply.pipe';
//import { PicturedItemSelectBoxModule } from 'src/app/components/library/pictured-item-select-box/pictured-item-select-box.component';
import { ScreenService } from '../../../services';
// import { StatusSelectBoxModule } from 'src/app/components/library/status-select-box/status-select-box.component';
import { getSizeQualifier } from '../../../services';
import { FormGroup } from '@angular/forms';
import { PicturedCountrySelectBoxModule } from '../pictured-country-select-box/pictured-country-select-box.component';

type CardData = Record<string, any>;

@Component({
  selector: 'app-rich-form',
  templateUrl: './rich-form.component.html',
  styleUrls: ['rich-form.component.scss'],
})
export class RichFormComponent {
  @ViewChild('form', { static: true }) form!: DxFormComponent;

  @Input() items: Record<string, any>[] = [];
  @Input() formType! : string;
  @Input() formwidth! : number;
  @Input() colCount: number = 2;

  @Input() title: string = '';

  @Output() dataChanged = new EventEmitter<any>();

  @Input() cardData!: CardData;

  getSizeQualifier = getSizeQualifier;

  assign = Object.assign;

  constructor(public screen: ScreenService, private changeDetectorRef : ChangeDetectorRef) 
  {
    
  }

  

  clearForm() {

    // for some reason this.form.instance.reset(), resetValues(),clear() could not clear the whole form fields, cleared one at a time
    this.form.instance.option('formData', {})
    
  }

  onFieldChange(fieldName?, value?, event? : any) {
    //const {isValid} = this.form.instance.validate();
    //if (!isValid) {
    //  return;
    //}
    

    if (fieldName) {
      
      this.cardData[fieldName] = event;
      this.dataChanged.emit({
        FormType : this.formType, 
        event: {
          dataField : fieldName,
          value : event
        }
       });
      return;
    }

    if(!this.formType && this.items?.length > 0){
      this.formType = this.items[0]['FormType'];
    }
    
    this.dataChanged.emit({
     FormType : this.formType, 
     event: event
    });
  }

  getFieldValue(cardData, fieldName) {
    return cardData[fieldName];
  }
}

@NgModule({
  imports: [
    ApplyPipeModule,
    DxButtonModule,
    DxDateBoxModule,
    DxFormModule,
    DxNumberBoxModule,
    DxToolbarModule,
    DxSelectBoxModule,
    DxScrollViewModule,
    DxTextBoxModule,
    DxValidatorModule,
    CommonModule,
    PicturedCountrySelectBoxModule,
   
  ],
  declarations: [RichFormComponent],
  exports: [RichFormComponent],
})
export class RichFormModule { }
